/**
 * Created by mac on 12/8/20
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    GUIDEWINDOW_TEXT_COLOR: new cc.Color(173, 85, 14, 255),
    TITLE_COLOR_YELLOW: new cc.Color(134, 56, 10, 255),
    TITLE_SHADOW: new cc.Color(255, 251, 126, 255)
});

cleverapps.overrideFonts(cleverapps.styles.DECORATORS, {
    WHITE_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.BLACK,
        size: 2
    },

    STARTQUESTWINDOW_DARK_SHADOW: {
        color: new cc.Color(255, 249, 221, 255),
        direction: cc.size(0, -3),
        blur: 0
    },

    GUIDEWINDOW_TEXT_SHADOW: {
        color: new cc.Color(255, 243, 236, 255),
        direction: cc.size(0, -2),
        blur: 0
    },

    SINGLE_PRODUCT_OFFER_SOFT_STROKE: {
        color: new cc.Color(255, 144, 0, 255),
        size: 3
    },

    CHESTTIMEMISSIONWINDOW_TITLE_TEXT_STROKE: {
        color: new cc.Color(4, 72, 246, 255),
        size: 2
    },

    CHESTTIMEMISSIONWINDOW_TITLE_TEXT_SHADOW: {
        color: new cc.Color(0, 120, 255, 155),
        direction: cc.size(0, -1),
        blur: 3
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PACKWINDOW_LABEL_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    QUEST_PROGRESS_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    WAND_PROGRESS_TEXT: {
        size: 30
    },

    INFO_TIMER_TEXT: {
        name: "nostroke",
        size: 26,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PASS_TITLE_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PASS_TIMER_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PASS_PROGRESS_IMAGE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_PROGRESS_POINT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    PASS_TICKET_TEXT: {
        size: 28,
        color: new cc.Color(247, 231, 25),
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_TICKET_SMALL_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_REWARD_TEXT: {
        size: 56,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    SINGLE_PRODUCT_OFFER_REWARD: {
        name: "big_digits",
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    RUINS_TIMER: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    CHESTTIMEMISSIONWINDOW_TITLE_TEXT: {
        size: 100,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.CHESTTIMEMISSIONWINDOW_TITLE_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.CHESTTIMEMISSIONWINDOW_TITLE_TEXT_SHADOW
    },

    BOOSTTIMEMISSIONWINDOW_REWARD_TEXT: {
        size: 50
    },

    COMPONENT_TIMER_TEXT: {
        size: 22,
        color: cleverapps.styles.COLORS.WHITE
    },

    FOG_BLOCKER_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    CARAVAN_REWARDS_BLOCK_TEXT: {
        name: "nostroke",
        size: 32,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    ENERGY_OFFER: {
        size: 85,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.overrideStyles(cleverapps.styles.InfoView, {
    minHeight: 120,
    minWidth: 130,
    minWidthWithDecorators: 240,

    padding: {
        x: 0,
        bottom: 22
    },

    pointer: {
        y: -1
    },

    decorators: [
        {
            image: bundles.merge.frames.info_liana1,
            x: { align: "left", dx: -5 },
            y: { align: "top", dy: 10 }
        },
        {
            image: bundles.merge.frames.info_liana2,
            x: { align: "right", dx: 6 },
            y: { align: "bottom", dy: -2 }
        }
    ],

    title: {
        width: 194,
        padding: {
            x: 40
        }
    },

    bar: {
        width: 196,
        height: 42,
        type: ScaledProgressBar.Types.blue,
        padding: {
            x: 26
        }
    },

    button: {
        width: 208,
        height: 70,
        padding: {
            x: 26
        }
    },

    thinButton: {
        width: 208,
        height: 60
    },

    guide: {
        x: { align: "right", dx: 25 },
        y: { align: "top", dy: 25 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.CustomerInfoView, {
    padding: {
        x: 25,
        top: 12,
        bottom: 22
    }
});

cleverapps.overrideStyles(cleverapps.styles.FieldInfoView, {
    padding: {
        x: 25,
        top: 12,
        bottom: 22
    }
});

cleverapps.overrideStyles(cleverapps.styles.MineableView, {
    progress: {
        width: 92,
        height: 19,

        upY: { align: "bottom", dy: 55 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ComponentTimer, {
    timer: {
        width: 160
    }
});

cleverapps.overrideStyles(cleverapps.styles.PrizeView, {
    width: 106,
    height: 97,

    padding: {
        x: 18,
        y: 14
    },

    pointer: {
        dy: 2
    },

    animation: {
        x: { align: "center" },
        y: { align: "center", dy: 0 }
    }
});

if (cleverapps.styles.CustomerIngredientViewInfoView) {
    cleverapps.overrideStyles(cleverapps.styles.CustomerIngredientViewInfoView, {
        height: 88,
        icon: {
            offsetY: 0
        },
        progress: {
            margin: -4,

            x: { align: "right", dx: -6 },
            y: { align: "bottom", dy: -10 }
        },
        checkMark: {
            x: { align: "right", dx: 15 },
            y: { align: "bottom", dy: -2 }
        }
    });
    cleverapps.overrideStyles(cleverapps.styles.CustomerIngredientViewInfoViewLarger, {
        height: 106,
        icon: {
            offsetY: 0
        },
        progress: {
            margin: -4,

            x: { align: "right", dx: -6 },
            y: { align: "bottom", dy: -10 }
        },
        checkMark: {
            x: { align: "right", dx: 15 },
            y: { align: "bottom", dy: -2 }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.GiftContentView, {
    width: 640,
    minHeight: 160
});

cleverapps.overrideStyles(cleverapps.styles.FogLockView.default, {
    content: {
        width: 54,
        height: 54
    },
    text: {
        x: { align: "center", dx: -10 },
        y: { align: "center", dy: 13 }
    },
    icon: {
        x: { align: "center", dx: -10 },
        y: { align: "center", dy: 12 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.FogLockView.expedition, {
    text: {
        x: { align: "center", dx: -10 },
        y: { align: "center", dy: 13 }
    },
    icon: {
        x: { align: "center", dx: -10 },
        y: { align: "center", dy: 12 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.FogBlockView, {
    openerWindow: {
        button: {
            y: { align: "bottom", dy: -60 },
            width: 200,
            height: 60,
            type: cleverapps.styles.UI.Button.Images.small_button_green
        }

    },

    opener: {
        height: 65,
        y: { align: "top", dy: 50 },

        text: {
            width: 210,
            x: { align: "center", dx: 21 },
            y: { align: "center", dy: 1 }
        },

        icon: {
            y: { align: "center", dy: 0 }
        }
    },

    blocker: {
        position: {
            x: { align: "center" },
            y: { align: "center", dy: 80 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.BuyFogWindow, {
    island: {
        height: 630,
        y: { align: "center", dy: 210 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PixelView, {
    collect: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -10 },
        delay: 300
    },
    timeScale: {
        base: 0.7,
        random: 0.3
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    items: {
        GoldItem: {
            icon: {
                scale: 1.12
            }
        },

        LivesItem: {
            icon: {
                scale: 1.15
            }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.WorkerView, {
    timer: {
        x: { align: "center", dx: -10 },
        y: { align: "bottom", dy: 0 }
    },

    miningAnimation: {
        x: { align: "center", dx: -12, leftDx: 8 },
        y: { align: "bottom", dy: 0 }
    },

    buildingAnimation: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 0 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.CastleGuideWindow, {
    firstStage: {
        foreground: false,

        components: [
            {
                x: -107,
                y: -166,
                scale: 0.8
            },
            {
                x: -4,
                y: -236,
                scale: 0.8
            },
            {
                x: 105,
                y: -166,
                scale: 0.8
            }
        ]
    },

    secondStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: -30 }
        },

        castle: {
            x: 0,
            y: 0,
            scale: 0.8
        },

        icon: {
            x: { align: "left", dx: 10 },
            y: { align: "center", dy: 0 },
            scale: 0.22
        },

        components: [
            {
                x: -94,
                y: 218,
                scale: 0.6
            },
            {
                x: 96,
                y: 200,
                scale: 0.7
            }
        ]
    },

    thirdStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: -10 }
        },

        castle: {
            x: 0,
            y: 0,
            scale: 0.9
        },

        light: {
            x: 0,
            y: 50
        },

        crystals: {
            x: 0,
            y: 50
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.CrystalGuideWindow, {
    secondStage: {
        foreground: {
            x: -15,
            y: 20,
            scale: 1.3
        }
    },

    thirdStage: {

        highlight: {
            dx: -5,
            dy: 20
        },

        units: [
            {
                x: 1,
                y: -254,
                dx: -5,
                dy: 10,
                scale: 1.1
            },
            {
                x: -109,
                y: -196,
                dx: 0,
                dy: 5,
                scale: 1.3
            },
            {
                x: 110,
                y: -176,
                dx: 0,
                dy: 5,
                scale: 1.3
            },
            {
                x: -8,
                y: -30,
                dx: 10,
                dy: 15,
                scale: 1.4
            }
        ]
    }
});

cleverapps.overrideStyles(cleverapps.styles.InstantWorkerView, {
    progress: {
        type: ScaledProgressBar.Types.blue_small,
        width: 90,
        x: 0,
        y: -50
    },

    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -29 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.OpenChestWindow, {
    watchButton: {
        unit: {
            x: { align: "center", dx: 97 },
            y: { align: "center", dy: 0 },
            scale: 1.3
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.BonusWorkerWindow, {
    animation: {
        leftWorkers: {
            reverse: false,
            margin: 0
        }
    },
    person: {
        scale: 1,
        x: { align: "center", dx: -680 },
        y: { align: "bottom", dy: -80 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.HeroIcon, {
    icon: {
        x: { align: "center", dx: -3 },
        y: { align: "bottom", dy: 51 },

        scale: 1
    },

    selection: {
        x: { align: "center" },
        y: { align: "center", dy: -1 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.UpgradableView, {
    level: {
        x: { align: "left", dx: -28 },
        text: {
            y: { align: "center", dy: 1 },
            maxWidth: 36
        }
    },

    progress: {
        type: ScaledProgressBar.Types.blue,
        width: 180,
        height: 36,

        text: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIcon, {
    producer: {
        y: { align: "bottom", dy: 35 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.BuyIngredientsWindow, {
    tile: {
        amountBackground: {
            width: 250,
            height: 100,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -72 }
        },

        amountText: {
            x: { align: "center" },
            y: { align: "center", dy: -68 }
        },

        title: {
            x: { align: "center" },
            y: { align: "center", dy: -162 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.UnitView, {
    mergeAnimation: {
        x: 0,
        y: 20
    },

    didMerge: {
        delay: 0.3
    }
});

cleverapps.overrideStyles(cleverapps.styles.UnitsShopCart, {
    item: {
        firstItem: {
            oneItem: {
                x: { align: "center", dx: -1 },
                y: { align: "bottom", dy: 88 }
            },
            twoItems: {
                x: { align: "center", dx: -15 },
                y: { align: "bottom", dy: 85 }
            }
        },

        secondItem: {
            x: { align: "center", dx: 15 },
            y: { align: "bottom", dy: 90 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.OrderIcon, {
    pin: {
        x: { align: "left" },
        y: { align: "top", dy: 3 }
    },

    button: {
        y: { align: "center", dy: -62 },
        height: 82
    }
});

cleverapps.overrideStyles(cleverapps.styles.IngredientOrderIcon, {
    icon: {
        scale: 1.7,
        help: {
            x: { align: "right", dx: 14 },
            y: { align: "top", dy: 10 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.UnitOnCell, {
    ground: {
        x: 6,
        y: -27
    }
});

cleverapps.overrideStyles(cleverapps.styles.LockedComponentView, {
    timer: {
        x: { align: "center", dx: 0 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.BUILDPASS], {
    height: 640,
    width: 1400,

    badges: [
        {
            x: { align: "right", dx: 46 },
            y: { align: "top", dy: -13 },
            width: 125,
            rotation: 10
        }
    ],

    rewards: {
        unit: {
            bppointsstar: {
                x: { align: "center", dx: -550 },
                y: { align: "center", dy: -220 },
                width: 540,
                rotation: 0
            },
            crystal: {
                x: { align: "center", dx: 540 },
                y: { align: "center", dy: -220 },
                width: 540,
                rotation: 0
            }
        }
    },

    button: {
        y: { align: "bottom", dy: -160 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.SALEPASS], {
    height: 640,
    width: 1200,

    offer: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 50 }
    },

    badges: [
        {
            x: { align: "right", dx: -150 },
            y: { align: "top", dy: 38 },
            width: 125,
            rotation: 10
        }
    ],

    rewards: {
        font: cleverapps.styles.FONTS.SINGLE_PRODUCT_OFFER_REWARD2,
        unit: {
            bppointscrystal: {
                x: { align: "center", dx: -545 },
                y: { align: "center", dy: -174 },
                width: 200,
                font: cleverapps.styles.FONTS.SINGLE_PRODUCT_OFFER_SALE_REWARD,
                rotation: 0
            }
        },

        soft: {
            x: { align: "center", dx: 535 },
            y: { align: "center", dy: -174 },
            width: 200,
            font: cleverapps.styles.FONTS.SINGLE_PRODUCT_OFFER_SALE_REWARD,
            rotation: 0
        }
    },

    person: { role: "worker", emotion: "happy" },

    button: {
        x: { align: "center", dx: -9 },
        y: { align: "bottom", dy: -160 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.TropicalMissionView, {
    margin: 50,

    table: {
        padding: 10,
        innerPadding: 12,
        margin: 5
    }
});

cleverapps.overrideStyles(cleverapps.styles.BarrelAdsWindow, {
    item: {
        iconNode: {
            x: { align: "center", dx: -5 },
            shining: false,
            noWrap: true
        },

        strip: {
            width: 305,
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 120 },

            amount: {
                x: { align: "center" },
                y: { align: "center", dy: 7 }
            }
        },

        title: {
            maxWidth: 300,
            y: { align: "bottom", dy: 47 }
        },

        button: {
            width: 300,
            height: 110
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SalePassWindow, {
    height: 1040,
    width: 1730,

    header: {
        x: { align: "center", dx: -10 },
        y: { align: "top", dy: -100 }
    },

    progress: {
        x: { align: "right", dx: -35 },
        y: { align: "bottom", dy: 35 }
    },

    tickets: {
        x: { align: "left", dx: 30 },
        y: { align: "bottom", dy: 30 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.BuildPassWindow, { //
    width: 1720,
    height: 1030,

    header: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -70 }
    },

    progress: {
        x: { align: "right", dx: -35 },
        y: { align: "bottom", dy: 35 }
    },

    tickets: {
        x: { align: "left", dx: 30 },
        y: { align: "bottom", dy: 30 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassHeader, {
    height: 121,
    timer: {
        height: 55,
        y: { align: "center", dy: 20 },
        tooltip: true,

        countdown: {
            x: { align: "center", dx: 15 },
            y: { align: "center", dy: 0 }
        },

        icon: {
            x: { align: "left", dx: -25 },
            y: { align: "center", dy: -2 }
        }
    },

    decor: {
        x: { align: "center", dx: -585 },
        y: { align: "center", dy: 32 }
    },

    pack: {
        x: { align: "right", dx: 15 },
        y: { align: "center", dy: -13 }
    },

    amount: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -88 }
    }

});

cleverapps.overrideStyles(cleverapps.styles.PassHeaderPack, {
    badge: {
        x: { align: "right", dx: 208 },
        y: { align: "center", dy: -36 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassHeaderPack[Offers.TYPES.SALEPASS], {
    badge: {
        x: { align: "right", dx: 177 },
        y: { align: "center", dy: -47 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassHeaderPack[Offers.TYPES.CLPASS], {
    badge: {
        x: { align: "right", dx: 55 },
        y: { align: "center", dy: -60 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassPackBadge, {
    text: {
        x: { align: "center", dx: 35 },
        y: { align: "center", dy: 5 },
        rotation: -15,
        width: 120
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassProgress, {
    height: 700,
    paddingX: 170,

    scroll: {
        x: { align: "center", dx: -6 },
        y: { align: "center", dy: 0 }
    },

    progressBar: {
        x: { align: "left", dx: 0 },
        y: { align: "center", dy: 4 },

        height: 37
    },

    line: {
        first: {
            y: { align: "center", dy: 190 }
        },
        second: {
            y: { align: "center", dy: -190 }
        },
        single: {
            x: { align: "right", dx: 5 },
            y: { align: "center", dy: 0 }
        },
        height: 713,
        scale9: cleverapps.UI.Scale9Rect.TwoPixelXY
    },

    tasks: {
        contentOffset: 65,
        height: 670,

        premiumReward: {
            y: { align: "center", dy: 190 }
        },

        reward: {
            y: { align: "center", dy: -190 }
        },

        bgs: {
            width: 240,
            height: 260
        },

        completedLevelIcon: {
            x: { align: "center", dx: 1 },
            y: { align: "center", dy: 2 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassRewardIcon, {
    shining: {
        x: { align: "center", dx: -3 },
        y: { align: "center", dy: -2 }
    },

    claimButton: {
        width: 170,
        height: 60,
        x: { align: "center" },
        y: { align: "top", dy: 55 }
    },

    attention: {
        x: { align: "right", dx: 0 },
        y: { align: "top", dy: 10 }
    },

    icon: {
        y: { align: "center", dy: 0 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassTickets, {
    free: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 10 }
    },

    premium: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -10 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassTicket, {
    height: 340,
    wideMargin: 10,

    free: {
        text: 235
    },

    text: {
        width: 210,
        height: 60
    },

    premium: {
        text: {
            width: 210,
            height: 90
        }
    },

    button: {
        width: 170,
        height: 60,
        scale: 1.2
    },

    checkmark: {
        x: { align: "center", dx: 75 },
        y: { align: "center", dy: 70 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassRulesWindow, {
    firstStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: -17 }
        }
    },

    secondStage: {
        unit: {
            x: 3,
            y: -10,
            scale: 1.3
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ExpeditionPassHeader, {
    title: {
        x: { align: "center" },
        y: { align: "center", dy: 30 }
    },

    amount: {
        x: { align: "center" },
        y: { align: "center", dy: -65 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassLastChanceWindow, {
    offerBadge: {
        x: { align: "right", dx: 120 },
        y: { align: "top", dy: 10 },
        rotation: 15
    },

    rewards: {
        ticket: {
            x: { align: "right", dx: 59 },
            y: { align: "bottom", dy: -50 },
            scale: 1
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.RuinsView, {
    timer: {
        x: { align: "center", dx: 0 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.RuinsWindow, {
    platesMargin: 40,
    ctaMargin: 30,

    plate: {
        width: 496,
        height: 500,

        toolHeight: 230,

        units: {
            marginY: 30,
            y: { align: "top", dy: -155 }
        },

        button: {
            y: { align: "bottom", dy: 20 }
        }
    },

    timer: {
        width: 320,
        height: 64,

        position: { x: 0, y: 5 }
    },

    unit: {
        amount: {
            x: { align: "left", dx: 92 },
            y: { align: "center", dy: 5 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ExpeditionPassWindow, {
    width: 1800,
    height: 980,

    header: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 5 }
    },

    progress: {
        x: { align: "right", dx: -35 },
        y: { align: "bottom", dy: 35 }
    },

    tickets: {
        x: { align: "left", dx: 30 },
        y: { align: "bottom", dy: 30 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SceneComponent, {
    clearColor: new cc.Color(15, 180, 187, 255)
});

cleverapps.overrideStyles(cleverapps.styles.SalePassRulesWindow, {
    secondStage: {
        unit: {
            x: -15,
            y: 5
        },
        ground: {
            scale: 1.2
        }
    },
    thirdStage: {
        ground: undefined
    }
});

cleverapps.overrideStyles(cleverapps.styles.BankView, {
    timer: {
        width: 160
    }
});

cleverapps.overrideStyles(cleverapps.styles.ThirdElementView, {
    plane: {
        x: { align: "center" },
        y: { align: "center", dy: 150 },

        speed: {
            x: -250,
            y: -250
        }
    },

    drop: {
        x: { align: "center" },
        y: { align: "center", dy: 31 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.GeneratorGuideWindow, {
    firstStage: {
        light: {
            y: -15
        }
    },

    secondStage: {
        container: {
            x: { align: "center", dx: 20 },
            y: { align: "center", dy: -10 }
        }
    },

    thirdStage: {
        light: {
            y: -20
        },

        result: {
            y: -30,
            scale: 2
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.BaseClanWindow, {
    banner: {
        x: { align: "left", dx: -226 },
        y: { align: "top", dy: 28 },

        emblem: {
            x: { align: "center", dx: -8 },
            y: { align: "center", dy: 38 }
        },

        title: {
            x: { align: "center", dx: 5 },
            y: { align: "top", dy: 50 },
            width: 480,

            text: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 29 },
                width: 350
            }
        }
    },

    tabs: {
        y: { align: "bottom", dy: 15 },
        height: 140,
        margin: 10,
        padding: {
            left: 20,
            right: 35
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ClansJoinTab, {
    padding: {
        x: -20,
        top: 85,
        bottom: 95
    },

    table: {
        padding: {
            left: -10,
            right: 0,
            top: 30,
            bottom: 35
        },
        innerPadding: 20
    },

    createClanButton: {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: 17 }
    },

    search: {
        bg: {
            x: { align: "left", dx: 95 },
            y: { align: "top", dy: 20 }
        },

        button: {
            x: { align: "left", dx: 20 },
            y: { align: "top", dy: 28 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ClansTopTab, {
    padding: {
        x: -20,
        top: -10,
        bottom: 0
    },

    table: {
        padding: {
            left: -10,
            right: 0,
            top: 30,
            bottom: 35
        },
        innerPadding: 20
    }
});

cleverapps.overrideStyles(cleverapps.styles.ClansInfoTab, {
    padding: {
        x: -20,
        top: -10,
        bottom: 100
    },

    table: {
        padding: {
            left: -10,
            right: 0,
            top: 30,
            bottom: 35
        },
        innerPadding: 20
    },

    requiredLevel: {
        width: 240,
        height: 88,

        levelBg: {
            x: { align: "right", dx: 45 },
            y: { align: "center", dy: 0 },
            height: 100
        },

        text: {
            width: 160,
            height: 80,
            x: { align: "center", dx: -20 },
            y: { align: "center" }
        },

        amount: {
            x: { align: "center", dx: -1 },
            y: { align: "center", dy: 5 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ClansTopRow, {
    place: {
        background: {
            width: 70,
            height: 70
        }
    },

    data: {
        offsetRight: 10
    }
});

cleverapps.overrideStyles(cleverapps.styles.ClansInfoRow, {
    text: {
        x: { align: "center", dx: -1 },
        y: { align: "center", dy: 5 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ClansCupWindow, {
    table: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -30 },
        height: 820,
        innerPadding: 20,

        padding: {
            x: 0,
            y: 30
        }
    },

    finishText: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 10 }
    },

    tabs: {
        x: { align: "left", dx: 70 },
        y: { align: "top", dy: 69 },
        padding: {
            top: 5,
            bottom: 15
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ClanMessageRow, {
    teammateHelp: {
        offsetX: 63
    }
});

cleverapps.overrideStyles(cleverapps.styles.AddClanWindow, {
    emblem: {
        underline: {
            x: { align: "center" },
            y: { align: "center", dy: -25 },
            height: 2
        },

        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 15 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ClansChatTab, {
    chatBg: {
        width: 1320,
        height: 850,
        x: { align: "center" },
        y: { align: "top", dy: 10 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.UI.CheckBox, {
    label: {
        offsetY: -8
    }
});

cleverapps.overrideStyles(cleverapps.styles.ThirdElementWindow, {
    infoBlock: {
        timer: {
            x: { align: "left", dx: 50 },
            y: { align: "center", dy: 10 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent, {
    tap: {
        x: { align: "left", dx: -380 },
        y: { align: "center", dy: 410 },
        zIndex: 3
    },
    pack: {
        offsetY: 205,
        offsetX: 300,
        title: {
            x: { align: "center", dx: 175 },
            y: { align: "center", dy: -125 },
            width: 200,
            font: cleverapps.styles.FONTS.LIGHT_PACK_BUTTON_TEXT
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.OfferButtonComponent, {
    badge: {
        position: {
            x: { align: "right", dx: 55 },
            y: { align: "top", dy: 35 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DeleteAccountWindow, {
    person: "worker"
});

cleverapps.overrideStyles(cleverapps.styles.SubscriptionWindow, {
    width: 1200,
    margin: 45
});

cleverapps.overrideStyles(cleverapps.styles.TileBadge, {
    tooltip: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 60 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DonorProgressWindow, {
    content: {
        x: { align: "center" },
        y: { align: "center", dy: 15 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.WorkerComponentTimer, {
    button: {
        height: 64,
        y: -52
    }
});

if (cleverapps.styles.laborday) {
    cleverapps.overrideStyles(cleverapps.styles.laborday, {
        fogBlockWandIcon: {
            x: { align: "left", dx: -26 },
            y: { align: "center", dy: 0 }
        }
    });
}

if (cleverapps.styles.PixelView[PixelsSwarm.FRIEND]) {
    cleverapps.overrideStyles(cleverapps.styles.PixelView[PixelsSwarm.FRIEND], {
        avatar: {
            width: 80,
            height: 80,
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "top", dy: 0 }
            }
        },
        message: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "top", dy: 80 }
            }
        },
        collect: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -310 },
            delay: 400
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.CharacterUnlockedWindow, {
    field: {
        offsetX: 20,
        offsetY: 460
    },
    character: {
        ribbon: {
            text: {
                y: { dy: 10 }
            },
            height: 160,
            width: 800,
            paddingX: 115,
            y: { align: "center", dy: 20 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MergeComponentView, {
    mergeCount: {
        text: { dy: 13 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DialogueViewHorizontal, {
    showAnimation: "fromBelow"
});

if (cleverapps.styles.QuestsWindowBar) {
    cleverapps.overrideStyles(cleverapps.styles.QuestsWindowBar, { prizeIconOffsetY: 5, lastPrizeIconOffsetY: 5 });
}
